import React from "react";
import Form from "react-bootstrap/Form";
import { SUPPORTED_LANGUAGES } from "../../i18n/supportedLanguages";
import { useTranslation } from "../../i18n/TranslationProvider";

const LanguageSelector = () => {
  const { language, setLanguage, t } = useTranslation();

  return (
    <Form.Group controlId="languageSelector">
      <Form.Control
        as="select"
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
      >
        {SUPPORTED_LANGUAGES.filter((item) => item.enabled).map((item) => (
          <option key={item.code} value={item.code}>
            {item.nativeLabel}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  );
};

export default LanguageSelector;